import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class unitMeasureservice {
  static async unitTypeList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdUnitType?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async unitTypeCreate(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdUnitType', payload))
    return Callback(err, res)
  }
  static async unitTypeDetail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdUnitType?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async unitTypeUpdate(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdUnitType', payload))
    return Callback(err, res)
  }
  static async unitTypeRemove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdUnitType', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdUnitType/import', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdUnitType/v2/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  static async unitList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdUnit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async unitCreate(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdUnit', payload))
    return Callback(err, res)
  }
  static async unitDetail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdUnit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async unitUpdate(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdUnit', payload))
    return Callback(err, res)
  }
  static async unitRemove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdUnit', payload))
    return Callback(err, res)
  }
}
